export default "__VITE_ASSET__DsjXCXT4__"